import script from "./summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary.vue?vue&type=script&setup=true&lang=ts"

import "./summary.vue?vue&type=style&index=0&id=8b18b000&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b18b000"]])

export default __exports__